// The browser's background polls say they are polls (personal-logins L4-fix OPS-1, M16): the access
// log coalesces a bulk read per person and route per 30 minutes only when the request carries
// X-Tracon-Poll: 1 (services/access-log.service.js). Only a timer's tick sends it: a first load, a
// wake from sleep and a mutation's refresh() are the person reading and are recorded as such.
export const POLL_HEADERS = Object.freeze({ 'X-Tracon-Poll': '1' });
export const pollOpts = (poll) => (poll ? { headers: POLL_HEADERS } : undefined);
